import React, { useContext } from "react";

const CustomerContext = React.createContext(null);

export default CustomerContext;

export function useCustomerContext() {
    return useContext(CustomerContext);
}
